import React from 'react';

export default function Pagination({ page, totalPages, onChange }) {
  if (totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-center md:justify-end gap-3 mt-6">
      <button
        disabled={page <= 1}
        onClick={() => onChange(page - 1)}
        className="px-3 py-1.5 rounded-xl text-sm font-medium bg-white/5 text-white/70 ring-1 ring-white/10
                   hover:bg-white/10 hover:text-white disabled:opacity-30 disabled:cursor-not-allowed transition"
      >
        ← Prev
      </button>
      <span className="text-xs font-semibold tracking-wide text-white/40">
        {page} <span className="text-white/20">/</span> {totalPages}
      </span>
      <button
        disabled={page >= totalPages}
        onClick={() => onChange(page + 1)}
        className="px-3 py-1.5 rounded-xl text-sm font-medium bg-white/5 text-white/70 ring-1 ring-white/10
                   hover:bg-white/10 hover:text-white disabled:opacity-30 disabled:cursor-not-allowed transition"
      >
        Next →
      </button>
    </div>
  );
}
